import { render } from "./StudentTestRecordHistoryChart.vue?vue&type=template&id=7c455979"
import script from "./StudentTestRecordHistoryChart.vue?vue&type=script&lang=js"
export * from "./StudentTestRecordHistoryChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__